<!-- Container-fluid starts-->
<div class="container-fluid">

  <div class="row">
    <div class="col-lg-12 col-md-12 col-12">
      <div class="card" >
        <div class="card-body" [ngStyle]="{'background': hexToRgbA(contentLocker.overlayColor)}">

          <div id="editor-live">
            <div id="frame" [ngStyle]="{
              'min-height': contentLocker.mainFrameMinHeight+'px',
              'height': contentLocker.mainFrameMinHeight+'px',
              'width': contentLocker.mainFrameWidth+'px',
              'background': contentLocker.mainFrameBackgroundColor,
              '-webkit-border-radius': '5px',
              '-moz-border-radius': '5px',
              'border-radius': '5px',
              'border': '1px solid #F7F7F7',
              'font-family': contentLocker.mainFrameFont,
              'border-width': contentLocker.mainFrameBorderSize+'px',
              'border-color': contentLocker.mainFrameBorderColor,
              'box-shadow': '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'
            }">

              <div id="close"></div>
              <div *ngIf="templateEditorStep === 'offers'">
                <div [ngStyle]="{
                  'color': contentLocker.h1FontColor,
                  'font-size': contentLocker.h1FontSize+'px',
                  'font-weight': contentLocker.h1FontWeight,
                  'text-align': contentLocker.h1TextAlign,
                  'width': contentLocker.h1Width+'%',
                  'margin-top': contentLocker.h1MarginTop+'px'
                }">{{contentLocker.h1Text}}
                </div>
                <div [ngStyle]="{
                  'color': contentLocker.h2FontColor,
                  'font-size': contentLocker.h2FontSize+'px',
                  'font-weight': contentLocker.h2FontWeight,
                  'text-align': contentLocker.h2TextAlign,
                  'width': contentLocker.h2Width+'%',
                  'margin-top': contentLocker.h2MarginTop+'px'
                }">{{contentLocker.h2Text}}
                </div>
                <table [ngStyle]="{
                  'margin': contentLocker.offersTableMargin+'px auto',
                  'width': contentLocker.offersTableWidth+'%',
                  'padding': contentLocker.offersTablePadding+'px',
                  'border-color': contentLocker.offersTableBorderColor,
                  'border-width': contentLocker.offersTableBorderSize+'px',
                  'font-family': contentLocker.mainFrameFont
                }">
                  <tr *ngFor="let i of noOffers" [ngStyle]="{'background-color': getOfferBackground(i) }">
                    <td [ngStyle]="{
                      'line-height': contentLocker.offerLineHeight+'px',
                      'padding': contentLocker.offerLinePadding+'px',
                      'text-align': contentLocker.offerTextAlign}"
                      >
                         <a href="#" (click)="false"
                            [ngStyle]="{'color': contentLocker.offerLinkColor, 'text-decoration': contentLocker.offerLinkDecoration, 'font-size': contentLocker.offerLinkFontSize+'px'}">Sample
                           offer</a>
                       </td>
                  </tr>
                </table>
                <div class="notice" [ngStyle]="{
                  'width': contentLocker.noticeWidth+'%',
                  'text-align': contentLocker.noticeTextAlign,
                  'font-size': contentLocker.noticeFontSize+'px',
                  'font-weight': contentLocker.noticeFontWeight,
                  'color': contentLocker.noticeFontColor,
                  'margin-top': contentLocker.noticeMarginTop+'px'
                  }">{{contentLocker.noticeText}}
                </div>
              </div>
              <div *ngIf="templateEditorStep === 'waiting'" id="waiting" [ngStyle]="{
                'margin-top': contentLocker.waitingMarginTop+'px',
                'width' : contentLocker.waitingWidth+'%',
                'text-align': contentLocker.waitingTextAlign,
                'color': contentLocker.waitingFontColor,
                'font-weight': contentLocker.waitingFontWeight
              }">
                <!-- <img *ngIf="contentLocker.waitingImage" [src]="contentLocker.waitingImage" alt="" [ngStyle]="{
                  'margin':  contentLocker.waitingImageMargin
                }"> -->
                <p [ngStyle]="{ 'font-size': contentLocker.waitingFontSize+'px'}">{{contentLocker.waitingText1}}</p>
                <p [ngStyle]="{ 'font-size': contentLocker.waitingFontSize+'px'}">{{contentLocker.waitingText2}} <strong>{{contentLocker.waitingLinkText}}</strong></p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-12 col-md-12 col-12">
        <div class="card">
          <div class="card-body">

            <div ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-pills" (navChange)="tabChange($event)" orientation="horizontal">
            
              <!-- TAB - General -->
            <ng-container ngbNavItem="general">
              <button ngbNavLink>General</button>

              <ng-template ngbNavContent>
                <div class="row">
                  <div class="col-lg-2 col-md-2 col-5">
                    <div class="form-group">
                      <label class="form-label">Content locker name</label>
                      <input class="form-control" type="text" placeholder="name" [(ngModel)]="contentLocker.lockerName">
                    </div>
                  </div>
                  <div class="col-sm-2">
                    <div class="form-group">
                      <label class="form-label">On unlock</label>
                      <select class="form-select btn-square"  [(ngModel)]="contentLocker.contentLockerUnlockType">
                        <option value="1">Close</option>
                        <option value="2">Redirect</option>
                        <option value="3">JavaScript Eval</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-lg-8" *ngIf="contentLocker.contentLockerUnlockType == 3">
                    <div class="form-group">
                      <label>Your script to eval</label>
                      <input type="text" class="form-control" placeholder="" [(ngModel)]="contentLocker.lockerUnlocklink">
                    </div>
                  </div>
                  <div class="col-lg-8" *ngIf="contentLocker.contentLockerUnlockType == 2">
                    <div class="form-group">
                      <label>Redirect to</label>
                      <input type="text" class="form-control" placeholder="" [(ngModel)]="contentLocker.lockerUnlocklink">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-1">
                    <div class="form-group">
                      <label class="form-label">Activate leads</label>
                      <select class="col-sm-10 form-select" [(ngModel)]="contentLocker.isLockerLeadsOn" (change)="onChangeVisible()">
                        <option [ngValue]="true">Yes</option>
                        <option [ngValue]="false">No</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-1" *ngIf="contentLocker.isLockerLeadsOn == true">
                    <div class="form-group">
                      <label class="form-label">No. of offers</label>
                      <input class="form-control" type="number" [(ngModel)]="contentLocker.offersNumbers" disabled>
                    </div>
                  </div>
                  <div class="col-sm-1" *ngIf="contentLocker.isLockerLeadsOn == true">
                    <div class="form-group">
                      <label class="form-label">Leads</label>
                      <input class="form-control" type="number" [(ngModel)]="sliderLeadsValue" disabled>
                    </div>
                  </div>
                  <div class="col-sm-5" *ngIf="contentLocker.isLockerLeadsOn == true">
                    <div class="custom-slider">
                      <p></p>
                      <ngx-slider [(ngModel)]="contentLocker.lockerLeadsInPercent" [options]="custSlideroptions" (mouseup)="onChangeLeads()">
                      </ngx-slider>
                    </div>
                    <span>
                      <small><b>Note:</b> The leads of all offers parameter means what % of all offers must be filled in by the Visitor to unlock the content. The value shown in the Leads field is an approximate amount in relation to the set parameter No. of offers. The actual number depends on the number of offers for country, type of device, etc. for the Visitor</small>
                    </span>
                  </div>
                </div>
              </ng-template>
            </ng-container>

            <!-- TAB - Overlay -->
            <ng-container ngbNavItem="overaly">
              <button ngbNavLink>Overlay</button>
              <ng-template ngbNavContent>
                <div class="row">
                  <div class="col-sm-1">
                    <div class="form-group">
                      <label class="form-label">Overlay color</label>
                      <input class="form-control" type="color" [(ngModel)]="contentLocker.overlayColor">
                    </div>
                  </div>
                  <div class="col-sm-2">
                    <div class="form-group">
                      <label class="form-label">Overlay opacity</label>
                      <input class=" col-sm-6 form-control digits" type="number" min="0" max="1" step="0.05" [(ngModel)]="contentLocker.overlayOpacity">
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-container>

            <!-- TAB - Main frame -->
            <ng-container ngbNavItem="mainframe">
              <button ngbNavLink>Main frame</button>
              <ng-template ngbNavContent>
                <div class="row">
                  <div class="col-sm-2">
                    <div class="form-group">
                      <label class="form-label">Font</label>
                      <select class="form-select" [(ngModel)]="contentLocker.mainFrameFont">
                        <option value="Georgia">Georgia</option>
                        <option value="Palatino Linotype">Palatino Linotype</option>
                        <option value="Book Antiqua">Book Antiqua</option>
                        <option value="Times New Roman">Times New Roman</option>
                        <option value="Arial">Arial</option>
                        <option value="Helvetica">Helvetica</option>
                        <option value="Arial Black">Arial Black</option>
                        <option value="Impact">Impact</option>
                        <option value="Lucida Sans Unicode">Lucida Sans Unicode</option>
                        <option value="Tahoma">Tahoma</option>
                        <option value="Verdana">Verdana</option>
                        <option value="Courier New">Courier New</option>
                        <option value="Lucida Console">Lucida Console</option>
                        <option value="initial">initial</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-1">
                    <div class="form-group">
                      <label class="form-label">Frame weight</label>
                      <input class="form-control" type="number" min="360" step="10" [(ngModel)]="contentLocker.mainFrameWidth">
                    </div>
                  </div>
                  <div class="col-sm-1">
                    <div class="form-group">
                      <label class="form-label">Frame height</label>
                      <input class="form-control" type="number" min="360" step="10" [(ngModel)]="contentLocker.mainFrameMinHeight">
                    </div>
                  </div>
                  <div class="col-sm-1">
                    <div class="form-group">
                      <label class="form-label">Bkgrd color</label>
                      <input type="color" class="form-control"  placeholder="" [(ngModel)]="contentLocker.mainFrameBackgroundColor">
                    </div>
                  </div>
                  <div class="col-sm-1">
                    <div class="form-group">
                      <label class="form-label">Border size</label>
                      <input class="col-sm-12 form-control" type="number" min="0" placeholder="border size" [(ngModel)]="contentLocker.mainFrameBorderSize">
                    </div>
                  </div>
                  <div class="col-sm-2">
                    <div class="form-group">
                      <label class="form-label">Border color</label>
                      <input class="col-sm-5 form-control" type="color" [(ngModel)]="contentLocker.mainFrameBorderColor">
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-container>

            <!-- TAB - Header -->
            <ng-container ngbNavItem="header">
              <button ngbNavLink>Header</button>
              <ng-template ngbNavContent>
                <div class="row">
                  <div class="col-sm-5">
                    <div class="form-group">
                      <label class="form-label">Text content</label>
                      <input type="text" class="form-control" placeholder="text content" [(ngModel)]="contentLocker.h1Text">
                    </div>
                  </div>
                  <div class="col-sm-1">
                    <div class="form-group">
                      <label class="form-label">Header width</label>
                      <input class="form-control" type="number" min="10" max="100" [(ngModel)]="contentLocker.h1Width">
                    </div>
                  </div>
                  <div class="col-sm-1">
                    <div class="form-group">
                      <label class="form-label">Margin top</label>
                      <input class="form-control" type="number" min="0" placeholder="margin top" [(ngModel)]="contentLocker.h1MarginTop">
                    </div>
                  </div>
                  <div class="col-sm-1">
                    <div class="form-group">
                      <label class="form-label">Text align</label>
                        <select class="form-select" [(ngModel)]="contentLocker.h1TextAlign">
                          <option value="left">Left</option>
                          <option value="center">Center</option>
                          <option value="right">Rigth</option>
                        </select>
                    </div>
                  </div>
                  <div class="col-sm-1">
                    <div class="form-group">
                      <label class="form-label">Font color</label>
                      <input   class="col-sm-12 form-control" type="color" [(ngModel)]="contentLocker.h1FontColor">
                    </div>
                  </div>
                  <div class="col-sm-1">
                    <div class="form-group">
                      <label class="form-label">Font size</label>
                      <input class="form-control" type="number" min="8" [(ngModel)]="contentLocker.h1FontSize">
                    </div>
                  </div>
                  <div class="col-sm-2">
                    <div class="form-group">
                      <label class="form-label">Font weight</label>
                      <select class="col-sm-8 form-select" [(ngModel)]="contentLocker.h1FontWeight">
                        <option value="100">Thin</option>
                        <option value="200">Light</option>
                        <option value="300">Book</option>
                        <option value="400">Regular</option>
                        <option value="500">Medium</option>
                        <option value="600">Semi-bold</option>
                        <option value="700">Bold</option>
                        <option value="800">Heavy</option>
                        <option value="900">Ultra-black</option>
                      </select>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-container>

            <!-- TAB - Sub Header -->
            <ng-container ngbNavItem="subheader">
              <button ngbNavLink>Sub Header</button>
              <ng-template ngbNavContent>
                <div class="row">
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label class="form-label">Text content</label>
                      <input type="text" class="form-control"  placeholder="text content" [(ngModel)]="contentLocker.h2Text" (change)="onChangeh2Text()" *ngIf="contentLocker.isLockerLeadsOn == false">
                      <input type="text" class="form-control"  disabled [(ngModel)]="contentLocker.h2Text" *ngIf="contentLocker.isLockerLeadsOn == true">
                    </div>
                  </div>
                  <div class="col-sm-1">
                    <div class="form-group">
                      <label class="form-label">Header width</label>
                      <input class="form-control" type="number" min="10" max="100" [(ngModel)]="contentLocker.h2Width">
                    </div>
                  </div>
                  <div class="col-sm-1">
                    <div class="form-group">
                      <label class="form-label">Margin top</label>
                      <input class="form-control" type="number" min="0" placeholder="margin top" [(ngModel)]="contentLocker.h2MarginTop">
                    </div>
                  </div>
                  <div class="col-sm-1">
                    <div class="form-group">
                      <label class="form-label">Text align</label>
                        <select class="form-select" [(ngModel)]="contentLocker.h2TextAlign">
                          <option value="left">Left</option>
                          <option value="center">Center</option>
                          <option value="right">Rigth</option>
                        </select>
                    </div>
                  </div>
                  <div class="col-sm-1">
                    <div class="form-group">
                      <label class="form-label">Font color</label>
                      <input   class="col-sm-12 form-control" type="color" [(ngModel)]="contentLocker.h2FontColor">
                    </div>
                  </div>
                  <div class="col-sm-1">
                    <div class="form-group">
                      <label class="form-label">Font size</label>
                      <input class="form-control" type="number" min="1" [(ngModel)]="contentLocker.h2FontSize">
                    </div>
                  </div>
                  <div class="col-sm-2">
                    <div class="form-group">
                      <label class="form-label">Font weight</label>
                      <select class="col-sm-8 form-select" [(ngModel)]="contentLocker.h2FontWeight">
                        <option value="100">Thin</option>
                        <option value="200">Light</option>
                        <option value="300">Book</option>
                        <option value="400">Regular</option>
                        <option value="500">Medium</option>
                        <option value="600">Semi-bold</option>
                        <option value="700">Bold</option>
                        <option value="800">Heavy</option>
                        <option value="900">Ultra-black</option>
                      </select>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-container>

            <!-- TAB - Offers -->
            <ng-container ngbNavItem="offers">
              <button ngbNavLink>Offers</button>
              <ng-template ngbNavContent>
                <div class="row">
                  <div class="col-sm-1">
                    <div class="form-group">
                      <label class="form-label">No. of offers</label>
                      <!-- <input class="form-control" type="number" min="3" [(ngModel)]="contentLocker.offersNumbers" (ngModelChange)="offerChange()"> -->
                      <input class="form-control" type="number" min="3" [(ngModel)]="contentLocker.offersNumbers" (ngModelChange)="offerChange()">
                    </div>
                  </div>
                  <div class="col-sm-1">
                    <div class="form-group">
                      <label class="form-label">Table width</label>
                      <input class="form-control" type="number"  min="5" max="100" step="5" [(ngModel)]="contentLocker.offersTableWidth">
                    </div>
                  </div>
                  <div class="col-sm-1">
                    <div class="form-group">
                      <label class="form-label">Table margin</label>
                      <input class="form-control" type="number" min="0" [(ngModel)]="contentLocker.offersTableMargin">
                    </div>
                  </div>
                  <div class="col-sm-1">
                    <div class="form-group">
                      <label class="form-label">Table padding</label>
                      <input class="form-control" type="number" min="0" [(ngModel)]="contentLocker.offersTablePadding">
                    </div>
                  </div>
                  <div class="col-sm-1">
                    <div class="form-group">
                      <label class="form-label">Text align</label>
                        <select class="form-select" [(ngModel)]="contentLocker.offerTextAlign">
                          <option value="left">Left</option>
                          <option value="center">Center</option>
                          <option value="right">Rigth</option>
                        </select>
                    </div>
                  </div>
                  <div class="col-sm-2">
                    <div class="form-group">
                      <label class="form-label">Table border size</label>
                      <input class="col-sm-5 form-control" type="number" min="0" [(ngModel)]="contentLocker.offersTableBorderSize">
                    </div>
                  </div>
                  <div class="col-sm-2">
                    <div class="form-group">
                      <label class="form-label">Table border color</label>
                      <input class="col-sm-5 form-control" type="color" [(ngModel)]="contentLocker.offersTableBorderColor">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-2">
                    <div class="form-group">
                      <label class="form-label">Offer line height</label>
                      <input class="col-sm-5 form-control" type="number" [(ngModel)]="contentLocker.offerLineHeight">
                    </div>
                  </div>
                  <div class="col-sm-2">
                    <div class="form-group">
                      <label class="form-label">Offer line padding</label>
                      <input class="col-sm-5 form-control" type="number" min="0"  [(ngModel)]="contentLocker.offerLinePadding">
                    </div>
                  </div>
                  <div class="col-sm-2">
                    <div class="form-group">
                      <label class="form-label">Offer link decoration</label>
                        <select class="col-sm-8 form-select" [(ngModel)]="contentLocker.offerLinkDecoration">
                          <option value="none">None</option>
                          <option value="underline">Underline</option>
                        </select>
                    </div>
                  </div>
                  <div class="col-sm-1">
                    <div class="form-group">
                      <label class="form-label">Offer link color</label>
                      <input class="form-control" type="color" [(ngModel)]="contentLocker.offerLinkColor">
                    </div>
                  </div>
                  <div class="col-sm-2">
                    <div class="form-group">
                      <label class="form-label">Offer link font size</label>
                      <input class="col-sm-5 form-control" type="number" min="8" [(ngModel)]="contentLocker.offerLinkFontSize">
                    </div>
                  </div>
                  <!-- <div class="col-sm-2">
                    <div class="form-group">
                      <label class="form-label">Offer link on hover color</label>
                      <input class="col-sm-5 form-control" type="color" [(ngModel)]="contentLocker.offerLinkHoverColor">
                    </div>
                  </div> -->
                </div>
                <div class="row">
                  <div class="col-sm-2">
                    <div class="form-group">
                      <label class="form-label">Even offer bkgrd color</label>
                      <input class="col-sm-5 form-control" type="color" [(ngModel)]="contentLocker.offerEvenBackgroundColor">
                    </div>
                  </div>
                  <div class="col-sm-2">
                    <div class="form-group">
                      <label class="form-label">Even offer bkgrd color opacity</label>
                      <input class="col-sm-5 form-control" type="number" min="0" max="1" step="0.05" [(ngModel)]="contentLocker.offerEvenBackgroundColorOpacity" >
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-container>

            <!-- TAB - Notice -->
            <ng-container ngbNavItem="notice">
              <button ngbNavLink>Notice</button>
              <ng-template ngbNavContent>
                <div class="row">
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label class="form-label">Text content</label>
                      <input type="text" class="form-control" placeholder="text" [(ngModel)]="contentLocker.noticeText">
                    </div>
                  </div>
                  <div class="col-sm-1">
                    <div class="form-group">
                      <label class="form-label">Notice width</label>
                      <input class="form-control" type="number" min="10" max="100" [(ngModel)]="contentLocker.noticeWidth">
                    </div>
                  </div>
                  <div class="col-sm-1">
                    <div class="form-group">
                      <label class="form-label">Margin top</label>
                      <input class="form-control" type="number" min="0" step="5" [(ngModel)]="contentLocker.noticeMarginTop">
                    </div>
                  </div>
                  <div class="col-sm-1">
                    <div class="form-group">
                      <label class="form-label">Text align</label>
                        <select class="form-control" [(ngModel)]="contentLocker.noticeTextAlign">
                          <option value="left">Left</option>
                          <option value="center">Center</option>
                          <option value="right">Rigth</option>
                        </select>
                    </div>
                  </div>
                  <div class="col-sm-1">
                    <div class="form-group">
                      <label class="form-label">Font color</label>
                      <input   class="col-sm-12 form-control" type="color" [(ngModel)]="contentLocker.noticeFontColor">
                    </div>
                  </div>
                  <div class="col-sm-1">
                    <div class="form-group">
                      <label class="form-label">Font size</label>
                      <input class="form-control" type="number" min="8" [(ngModel)]="contentLocker.noticeFontSize">
                    </div>
                  </div>
                  <div class="col-sm-2">
                    <div class="form-group">
                      <label class="form-label">Font weight</label>
                      <select class="col-sm-8 form-select" [(ngModel)]="contentLocker.noticeFontWeight">
                        <option value="100">Thin</option>
                        <option value="200">Light</option>
                        <option value="300">Book</option>
                        <option value="400">Regular</option>
                        <option value="500">Medium</option>
                        <option value="600">Semi-bold</option>
                        <option value="700">Bold</option>
                        <option value="800">Heavy</option>
                        <option value="900">Ultra-black</option>
                      </select>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-container>

            <!-- TAB - Waiting screen -->
            <ng-container ngbNavItem="waiting">
              <button ngbNavLink>Waiting screen</button>
              <ng-template ngbNavContent>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label class="form-label">First text</label>
                      <input class="form-control" type="text" placeholder="first text" [(ngModel)]="contentLocker.waitingText1">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label class="form-label">Second text</label>
                      <input class="form-control" type="text" placeholder="second text" [(ngModel)]="contentLocker.waitingText2">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-1">
                    <div class="form-group">
                      <label class="form-label">Width</label>
                      <input class="form-control" type="number" min="10" max="100" [(ngModel)]="contentLocker.waitingWidth">
                    </div>
                  </div>
                  <div class="col-sm-1">
                      <div class="form-group">
                        <label class="form-label">Margin top</label>
                        <input class="col-sm-10 form-control" type="number" min="0" step="10"  [(ngModel)]="contentLocker.waitingMarginTop">
                      </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label class="form-label">Go back link text</label>
                      <input class="form-control" type="text" placeholder="width" [(ngModel)]="contentLocker.waitingLinkText">
                    </div>
                  </div>
                  <div class="col-sm-1">
                    <div class="form-group">
                      <label class="form-label">Text align</label>
                        <select class="form-select" [(ngModel)]="contentLocker.waitingTextAlign">
                          <option value="left">Left</option>
                          <option value="center">Center</option>
                          <option value="right">Right</option>
                        </select>
                    </div>
                  </div>
                  <div class="col-sm-1">
                    <div class="form-group">
                      <label class="form-label">Font color</label>
                      <input   class="col-sm-12 form-control" type="color" [(ngModel)]="contentLocker.waitingFontColor">
                    </div>
                  </div>
                  <div class="col-sm-1">
                    <div class="form-group">
                      <label class="form-label">Font size</label>
                      <input class="form-control" type="number" min="8" [(ngModel)]="contentLocker.waitingFontSize" >
                    </div>
                </div>
                <div class="col-sm-2">
                  <div class="form-group">
                    <label class="form-label">Font weigth</label>
                    <select class="col-sm-8 form-select" [(ngModel)]="contentLocker.waitingFontWeight">
                      <option value="100">Thin</option>
                      <option value="200">Light</option>
                      <option value="300">Book</option>
                      <option value="400">Regular</option>
                      <option value="500">Medium</option>
                      <option value="600">Semi-bold</option>
                      <option value="700">Bold</option>
                      <option value="800">Heavy</option>
                      <option value="900">Ultra-black</option>
                    </select>
                  </div>
                </div>
                </div>
              </ng-template>
            </ng-container>
          </div>   
          <div [ngbNavOutlet]="nav" class="ms-4"></div> 
       
          <div class="card-footer btn-showcase">
            <button class="btn btn-pill btn-sm btn-info" type="button" placement="top" ngbTooltip="save new gateway" (click)="onSave()">
                Save</button>
            <button class="btn btn-pill btn-sm btn-info" type="button" placement="top" ngbTooltip="return to gateways" (click)="onCancel()">
                Cancel</button>
            </div>
        </div>
    </div>
  </div>
</div>
<!-- Container-fluid Ends-->
